import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import messages from './ChargingPointCard/messages'
import Distance from 'commons/js/ui/Distance'
import styled from 'styled-components'
import { themeFontWeight, themeColor, themeFontSize } from '@elparking/components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

const DistanceRightBlock = styled.span`
    font-size: ${({ fontSize }) => themeFontSize(fontSize)}
    font-weight: ${themeFontWeight('book')};
    line-height: 14px;
    display: inline-block;
    color: ${themeColor('gray')};
    margin-left: 8px;
    &:before {
        content: '·';
        margin-right: 8px;
    }
    ${mediaScreenMobile} {
        &:before {
            display: none;
        }
    }
 `

const DistanceBlock = ({ distance, fontSize }) => (
    <DistanceRightBlock fontSize={fontSize}>
        <FormattedMessage
          {...messages.distance}
          values={{
            distance: <Distance fontSize={fontSize} fontWeight='book' color='gray' distance={distance} />,
        }}
    />
    </DistanceRightBlock>
)

DistanceBlock.propTypes = {
    distance: PropTypes.number,
    fontSize: PropTypes.string,
}

DistanceBlock.defaultProps = {
    fontSize: 'small',
}

export default DistanceBlock
